import LabelsTable from './LabelsTable';

export default LabelsTable;
